import * as api from "../api/builds.api";

const lastTimeKey = "lasttime";
const previousIndexKey = "previousIndex";

export default async function CheckForReload() {
	// How long until we run the test... 2 minutes (as milliseconds)
	const ms = 120000; // 2m * 60sec * 1000mx
	const now = new Date().getTime();
	const lastTime = parseInt(localStorage.getItem(lastTimeKey), 10);
	// console.log("last time", lastTime);

	if (isNaN(lastTime) || lastTime === 0) {
		// console.log("lasttime is not set... ", lastTime);
		localStorage.setItem(lastTimeKey, now.toString());
		return;
	}
	if (now - lastTime < ms) {
		// console.log("UNDER... ", now - lastTime, " < ", ms);
		return;
	}

	// We need to check it.
	localStorage.setItem(lastTimeKey, now.toString());

	checkBaseDoc();
	// console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>check it");
}

async function checkBaseDoc() {
	const bdt = await api.version();
	if (bdt === "") {
		// console.log("invalid bdt ");
		return;
	}

	// console.log("BDT", bdt);

	const bdtFromStorage = getInStorage();
	if (!bdtFromStorage) {
		// console.log("set BDT (as it was not there) in localStorage as ", bdt);
		localStorage.setItem(previousIndexKey, bdt);
		return;
	}

	// console.log(typeof bdtFromStorage, "bdtfromstorage");
	// console.log(typeof bdt, "bdt");
	if (bdtFromStorage !== bdt) {
		localStorage.setItem(previousIndexKey, bdt);
		// console.log("set BDT (BEFORE RELOAD) in localStorage as ", bdt);
		setTimeout(() => window.location.reload(), 15);
		// } else {
		// console.log("no need to reload");
	}
}

function getInStorage() {
	const prev = localStorage.getItem(previousIndexKey);
	if (prev === null || prev === undefined) {
		return false;
	}
	return prev;
}
